<p class="bigger">
Deine <span class="highlight">PRIVATSPHÄRE</span> ist uns wichtig!
</p>
<p class="bigger">
  Diese Web-App benötigt keine Zugriffsberechtigungen und greift daher auf keinerlei Funktionen und Daten Deines Smartphones zu.
  Da es sich um eine Web-App handelt, lösche die Website-Daten Deines Browsers erst dann, wenn Du Deine Ergebnisse als PDF heruntergeladen hast. Solltest Du das Gerät mit anderen zusammen benutzen, vergiss nicht, nach Benutzung der App, Deine Daten auf dem Gerät zu löschen.
  Wie das geht, erfährst Du <a href="/app/data-policy">hier</a>.

</p>
